import { useCallback } from 'react'
import { useSearchParams } from 'react-router'

const VIEW_PARAM = 'view'
const TABLE_VIEW = 'table'

/** Whether charts are shown as tables, kept in the URL (`view=table`) so the view can be shared. */
export const useViewAsTable = () => {
  const [params, setParams] = useSearchParams()
  const asTable = params.get(VIEW_PARAM) === TABLE_VIEW
  const setAsTable = useCallback(
    (on: boolean) =>
      setParams(
        current => {
          const next = new URLSearchParams(current)
          if (on) next.set(VIEW_PARAM, TABLE_VIEW)
          else next.delete(VIEW_PARAM)
          return next
        },
        { replace: true }
      ),
    [setParams]
  )
  return { asTable, setAsTable }
}
